/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { configureStore } from "@reduxjs/toolkit";
import { useDispatch as useAppDispatch, useSelector as useAppSelector } from "react-redux";
import { apiPersistModelMiddleware } from "./api-persist-model.middleware";
import reducers from "./reducers";


const store = configureStore({
    reducer: reducers,
    middleware (getDefaultMiddleware) {
        return getDefaultMiddleware().concat(apiPersistModelMiddleware);
    }
});

const { dispatch } = store;

const useDispatch = () => useAppDispatch();
const useSelector = useAppSelector;

export { dispatch, store, useDispatch, useSelector };

